import styled from 'styled-components'
import { Loading } from './StyledTitle'

export const ErrorMsg = styled(Loading)`
   line-height: 1.3;
`
